<div class="PolicyDashboard">
    <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label>{{'Please Wait,Processing..'|translate }}</label>
    </div>

    <div class="container-fluid">

        <div class="row">

            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 proposals">

                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-6">
                                    <h3 class="panel-title">{{'Payment Status'| translate}}</h3>
                                </div>
                                <!-- <div class="col col-xs-6 text-right">
                                    <button type="button" class="btn btn-sm btn-primary btn-create">Create New</button>
                                  </div> -->
                            </div>
                        </div>
                        <div class="panel-body">

                            <div class="PaymentForm">


                                <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'Proposal Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <input type="text" disabled class="form-control" [ngModel]="ProposalNo" />

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'Insured Name' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <input type="text" disabled class="form-control" [ngModel]="InsuredName" />

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'Premium' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <!-- <input type="text" disabled class="form-control" [ngModel]=" fortStatus.Amt | number : '1.2-2'"/> -->
                                        <input type="text" disabled class="form-control" [ngModel]="TotalPremium" />

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'Payment Date' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <!-- <input type="text" disabled class="form-control" [ngModel]="fortStatus.TransDate| date:'dd/MM/yyyy'"/> -->
                                        <input type="text" disabled class="form-control" [ngModel]="PaymentDate | date:'dd/MM/yyyy'" />

                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'Transaction ID' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <input type="text" disabled class="form-control" />

                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-lg-3">
                                        <label>{{'PaymentStatus' | translate }}</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <textarea disabled class="form-control" rows="2" *ngIf="objmdlCheckPaymentStatusRes.PaymentStatus == '1'">Payment successful.</textarea>
                                        <textarea disabled class="form-control" rows="2" *ngIf="objmdlCheckPaymentStatusRes.PaymentStatus != '1'">Your Payment Failed</textarea>

                                    </div>
                                </div>

                            </div>



                        </div>


                    </div>

                </div>

            </div>
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>

        </div>
    </div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortNew/PayfortStatusNew/PayfortStatusNew.html